import type React from "react";
import { Form, type ModalProps } from "react-bootstrap";
import type {
  DocumentSubType,
  // Interrogatory has correctly typed primary keys
  Interrogatory,
  MiscContent,
} from "@/briefpoint-client";
import type { QuestionListItems } from "@/components/DocumentWizard/PropoundDocumentReview";
// TODO: remove style cross-dependency
import styles from "@/components/DocumentWizard/PropoundDocumentReview/PropoundDocumentReview.module.scss";
import { Modal } from "@/components/Modals/Modal";
import { ADD_POSITION } from "@/lib/constants";
import type { CaseResponse, DocumentResponse } from "@/lib/types";
import QuestionsTableDiscRequest from "@/screens/Library/QuestionsTableDiscRequest";

interface RequestAddFromLibProps extends ModalProps {
  addPosition: string;
  confirmText: string;
  selectedDocument: DocumentResponse | undefined;
  docSubType?: DocumentSubType | undefined;
  showLibrary: boolean;
  modalSaving: boolean;
  caseInfo: CaseResponse | undefined;
  checkedItems: QuestionListItems[];
  questions: MiscContent[] | null;
  filteredSourceIdRequests: Interrogatory[] | undefined;
  tagSectionToOpen?: string;
  tagIdToFind?: number;
  showPositionControls?: boolean;
  handleRadioChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleShowLibrary: () => void;
  addToGeneratedList: () => Promise<void>;
  determineCheck: (id: string | undefined) => boolean | undefined;
  handleCheckboxChange: (
    id: string | undefined,
    checked: boolean,
    parentTag: string,
    content: string | null | undefined,
    question?: MiscContent,
  ) => void;
  setCheckedItems: React.Dispatch<React.SetStateAction<QuestionListItems[]>>;
}

const ModalRequestAddFromLib = ({
  addPosition,
  confirmText,
  selectedDocument,
  showLibrary,
  modalSaving,
  caseInfo,
  docSubType,
  checkedItems,
  questions,
  filteredSourceIdRequests,
  tagSectionToOpen,
  tagIdToFind,
  showPositionControls = true,
  handleRadioChange,
  handleShowLibrary,
  addToGeneratedList,
  determineCheck,
  handleCheckboxChange,
  setCheckedItems,
}: RequestAddFromLibProps) => {
  return (
    <Modal
      show={showLibrary}
      onClose={handleShowLibrary}
      onConfirm={addToGeneratedList}
      confirmText={confirmText}
      showCancelButton={false}
      preventBackgroundClick={false}
      shouldModalFocusItself={false}
      size="xl"
      title="Add From Library"
      disableConfirmButton={checkedItems.length === 0 || !addPosition}
      confirming={modalSaving}
    >
      <div className={`${styles.fieldContainer} ${styles.modal}`}>
        {questions && (
          <div className="library-container">
            <QuestionsTableDiscRequest
              questions={questions}
              subType={docSubType ?? selectedDocument?.info?.documentSubType}
              filteredSourceIdRequests={filteredSourceIdRequests}
              determineCheck={determineCheck}
              setCheckedItems={setCheckedItems}
              handleCheckboxChange={handleCheckboxChange}
              caseType={caseInfo?.caseType ?? undefined}
              caseInfo={caseInfo}
              checkedItems={checkedItems}
              tagSectionToOpen={tagSectionToOpen}
              tagIdToFind={tagIdToFind}
            />
            {showPositionControls && (
              <div className={styles.questionsRadio}>
                <span className="section-label">Add to</span>
                <Form.Check
                  type="radio"
                  label="Beginning of requests"
                  name="beginning-request-order"
                  id="order-beginning"
                  value="start"
                  checked={addPosition === ADD_POSITION.START}
                  onChange={handleRadioChange}
                />
                <Form.Check
                  type="radio"
                  label="End of requests"
                  name="end-request-order"
                  id="order-end"
                  value="end"
                  checked={addPosition === ADD_POSITION.END}
                  onChange={handleRadioChange}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalRequestAddFromLib;
